<template>
    <div class="main_unit report">
        <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        <component v-if="!isLoading"
                   :is="currentPage()"
                   :data="data"
                   :error-text="errorText"
                   :validation-error-text="validationErrorText"
                   :is-loading="isLoading"
                   :selectDate="selectDate"
                   :year = "date.getFullYear()"
                   :month = "date.getMonth() + 1"
                   :day = "date.getDate()"
                   :topButtonNo.sync = "topButtonNo"
                   @complete = "$emit('update:topButtonNo', null)"
                   :ref="currentPage()"
        ></component>
    </div>
</template>

<script>
    import MonthlyCheckReport from '@/app/components/MonthlyCheckReport.vue'
    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'
    export default {
        name: 'ReportMonthly',
        components: {
            PulseLoader,
            MonthlyCheckReport,
            Message
        },
        filters: {
            convertNull: function (value) {
                return value === null ? ' ': value
            }
        },
        props: {
            date: {
                type: Date,
                required: true,
            },
            confirmed: {
                type: Boolean,
                required: true
            },
            commentReFlg:{
                type: Boolean,
                required: true
            },
            topButtonNo: {
                type: Number,
                required: true
            },
        },
        data: function () {
            return {
                commentFlg: false,
                isLoading: true,
                index : 0,
                data: {
                    comment: {},
                    monthlyCheck: {
                        comment: '',
                        lastCommentDate: '',
                        commentHistoryFlg: '',
                    },
                    isAlert:0,
                },
                page: [
                    'monthlyCheck',
                ],
                errorText: '',
                validationErrorText: '',
                reportType: 4,
                alertMessage:'入力エラーがあります。'
            }
        },
        computed: {
            managerName: function () {
                return this.$store.getters['store/adminName']
            },
            brandPath: function () {
                return this.$route.params.brandPath
            },
            role: function () {
                return Number(this.$store.getters['manager/manager'].authorityKbn)
            },
            isStoreManager: function () {
                return this.role === 4
            },
            isCompanyManager: function () {
                return this.role === 2
            },
            isOtherManager: function () {
                return this.role === 6
            },
            selectDate: function(){
                var selectDate = this.date.getFullYear() + '/' + (this.date.getMonth() + 1) + '/' + this.date.getDate();
                return selectDate;
            }
        },
        watch: {
            confirmed (value) {
                if (value === true) {
                    this.submit()
                }
            },
            '$route': function () {
                this.fetchData()
            },
            // コメント差分
            commentFlg:function(){
                if(this.commentFlg){
                    // 親のフラグを操作
                    this.$parent.commentFlg = true;
                }
                else{
                    this.$parent.commentFlg = false;
                }
            },
            commentReFlg:function(){
                // 親の変更に伴い、このパラメータを変更する
                if(this.commentReFlg){
                    // 親のフラグを操作
                    this.commentFlg = true;
                }
                else{
                    this.commentFlg = false;
                }
            }
        },
        methods: {
            currentPage: function () {
                const page = [
                    'MonthlyCheckReport',
                ]

                return page[this.index]
            },
            hasProperty: function (obj,key) {
                return !!(obj) && Object.prototype.hasOwnProperty.call(obj, key)
            },
            getApiUrl: function () {
                let brand = this.$store.getters['brand/data']
                let store = this.$store.getters['store/data']
                return this.$apiEndpoint + 'manage/brand/' + brand.id + '/store/' + store.store_id + '/monthlyreport/' + this.date.getFullYear() + '/' + (this.date.getMonth() + 1) + '/' + this.date.getDate()
            },
            fetchData: function () {
                this.isLoading = true

                let url = this.getApiUrl()
                this.$axios.get(url).then(response => {
                        this.data.monthlyCheck.comment = response.data.comment.monthlyCheck
                        this.data.lastDatetime = response.data.comment.lastDatetime
                        this.data.commentHistoryFlg = response.data.comment.commentHistoryFlg
                }).catch(err => {
                    let error = {
                        button: {
                            path: {name: 'top', params:{brandPath: this.brandPath}}
                        }}
                    if (err.customError.code == 401) {
                        //店舗管理者のtokenエラーの場合
                        this.$cookies.set('user-api-token', '', 0)
                        this.$store.dispatch('store/doClear')
                    }
                    if (err.customError) {
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isLoading = false)
            },
            clearError: function () {
                this.validationErrorText = ''
                this.errorText = ''
            },
            submit: function () {
                let validationResult = null
                let request = {
                    'report_type': this.reportType
                }
                const url = this.getApiUrl()

                this.clearError()

                let requestComment = ''
                let commentsDatetime = ''
                if (this.isStoreManager) {
                    requestComment = this.data.monthlyCheck.comment.storeManager.comment
                    commentsDatetime = this.data.monthlyCheck.comment.storeManager.commentsDatetime
                    request.is_alert = 0;
                } else if (this.isCompanyManager) {
                    requestComment = this.data.monthlyCheck.comment.companyManager.comment
                    commentsDatetime = this.data.monthlyCheck.comment.companyManager.commentsDatetime
                    request.is_alert = this.data.isAlert;
                } else {
                    requestComment = this.data.monthlyCheck.comment.otherManager.comment
                    commentsDatetime = this.data.monthlyCheck.comment.otherManager.commentsDatetime
                    request.is_alert = this.data.isAlert;
                }

                validationResult = this.validateLength(requestComment)
                request.comment = requestComment
                request.comments_datetime = commentsDatetime

                if (! validationResult.result) {
                    this.validationErrorText = validationResult.message
                    this.$emit('submitted', false)
                    this.scrollTop();
                    return
                }

                let result = null
                this.$axios.post(url, request)
                    .then(response => {
                            result = true
                        if (this.isStoreManager) {
                            this.$set(this.data.monthlyCheck.comment.storeManager, 'commentsDatetime', response.data.commentList.monthlyCheck.storeManager.commentsDatetime)
                            this.$set(this.data.lastDatetime.storeManager, 'commentsDatetime', response.data.commentList.lastDatetime.storeManager.commentsDatetime)
                            this.$set(this.data.commentHistoryFlg, 'staffHistoryFlg', response.data.commentList.commentHistoryFlg.staffHistoryFlg)
                        } else if (this.isCompanyManager) {
                            this.$set(this.data.monthlyCheck.comment.companyManager, 'commentsDatetime', response.data.commentList.monthlyCheck.companyManager.commentsDatetime)
                            this.$set(this.data.lastDatetime.companyManager, 'commentsDatetime', response.data.commentList.lastDatetime.companyManager.commentsDatetime)
                            this.$set(this.data.commentHistoryFlg, 'companyHistoryFlg', response.data.commentList.commentHistoryFlg.companyHistoryFlg)
                        } else {
                            this.$set(this.data.monthlyCheck.comment.otherManager, 'commentsDatetime', response.data.commentList.monthlyCheck.otherManager.commentsDatetime)
                            this.$set(this.data.lastDatetime.otherManager, 'commentsDatetime', response.data.commentList.lastDatetime.otherManager.commentsDatetime)
                            this.$set(this.data.commentHistoryFlg, 'otherHistoryFlg', response.data.commentList.commentHistoryFlg.otherHistoryFlg)
                        }

                        if(this.currentPage() == 'MonthlyCheckReport'){
                            this.$refs.MonthlyCheckReport.updateUserCommentDatetime()
                        }
                    }).catch(err => {
                    result = false
                    let error = {
                        button: {
                            path: {name: 'top', params: { brandPath: this.brandPath }}
                        }}
                    if (err.customError) {
                        if (err.customError.code == 400) {
                            this.errorText = err.customError.message
                            this.scrollTop();
                            return
                        } else if (err.customError.code == 401) {
                            //店舗管理者のtokenエラーの場合
                            this.$cookies.set('user-api-token', '', 0)
                            this.$store.dispatch('store/doClear')
                        } else if (err.customError.code == 409) {
                            this.errorText = err.customError.message
                            this.scrollTop();
                            return
                        }
                        error = Object.assign(error, err.customError)
                    }
                    this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.$emit('submitted', result))
            },
            validateLength: function (comment) {
                if (this.isString(comment) && comment.length > 200) {
                    return { result: false, message: '総括コメントは200文字以下で入力してください。' }
                }
                return { result: true, message: '' }
            },
            isString: function (obj) {
                return typeof (obj) === 'string' || obj instanceof String
            },
            scrollTop() {
                window.scrollTo(0,0);
            },
        },
        mounted () {
            this.fetchData()
        }
    }
</script>
